import { MobilePhonePaymentQuestion } from '@hb/domain/steps/financial-obligation';
import { FinancialObligationsStoreService } from '@hb/modules/financial-obligations/financial-obligations-store.service';
import { FieldSubject } from '@hb/domain/field-subject';
import { money } from '@hb/builder';
import { AbstractStoreInjectOption } from '@hb/services/store/abstract-store-inject.service';

import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Money } from '@ap/interface-bspc-core';

@Injectable({
    providedIn: 'root'
})
export class MobilePhonePaymentStoreService extends AbstractStoreInjectOption<MobilePhonePaymentQuestion> implements OnDestroy {
    protected readonly store = inject(FinancialObligationsStoreService);
    protected readonly lastQuestion = MobilePhonePaymentQuestion.SUMMARY;

    private mobilePhoneSubscription: Subscription;
    private readonly amountSubject: FieldSubject<Money>;

    constructor() {
        super();
        this.init();

        const initialValues = this.getInitialValues();

        this.amountSubject = new FieldSubject<Money>(initialValues);

        this.subscriptions();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.mobilePhoneSubscription.unsubscribe();
        this.activeQuestionSubject.unsubscribe();
        this.amountSubject.unsubscribe();
    }

    update(): void {
        this.store.setMobilePhonePayment(this.amountSubject.value);
    }

    setAmount(amount: string): void {
        this.amountSubject.next(money(amount));
    }

    getAmount(): Money {
        return this.amountSubject.value;
    }

    getInitialValues(): Money {
        return this.store.getFinancialObligationState()?.mobile_phone_payment_amount;
    }

    private subscriptions(): void {
        this.amountSubject.asObservable().subscribe(() => this.update());
        this.mobilePhoneSubscription = this.store.getFinancialObligationsOptions().subscribe((options) => {
            if (!options.mobilePhonePayment) {
                this.amountSubject.next(null);
            }
        });
    }
}
